export default function InputField({
  label,
  register,
  name,
  error,
  placeholder,
  type = "text",
  disabled,
}) {
  return (
    <div className="w-full flex flex-col gap-1">
      <label className="font-medium text-gray-800">{label}</label>

      <input
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        {...register(name)}
        className="
    bg-[#F7F9FA]
    border border-gray-300
    rounded-lg
    w-full
    px-4 py-[10.5px]
    focus:outline-none
    focus:ring-2
    focus:ring-[#1FADC6]

    disabled:bg-[#F1F5F9]
    disabled:text-gray-500
    disabled:border-gray-200
    disabled:cursor-not-allowed
    disabled:focus:ring-0
  "
      />

      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
}
